import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=18f4a2e1&scoped=true&"
import script from "./groups.js?vue&type=script&lang=js&"
export * from "./groups.js?vue&type=script&lang=js&"
import style0 from "./groups.scss?vue&type=style&index=0&id=18f4a2e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f4a2e1",
  null
  
)

export default component.exports